// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"338":"9eb2c923","455":"9eb2c923","457":"cf08d67e","520":"9eb2c923","631":"9eb2c923"}[chunkId] + ".chunk.css";
};